import { memo } from 'react';

import type { PlanRevampIconProperties } from './types';

/**
 * Blox-Design plan toolbar — filled dropdown chevron (node 75644:10724).
 */
const PlanToolbarChevronDownIcon = ({
  width = 10,
  height = 6,
  color = 'currentColor',
}: PlanRevampIconProperties) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 10 6'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden
  >
    <path d='M0 0 L10 0 L5 6 Z' fill={color} />
  </svg>
);

export default memo(PlanToolbarChevronDownIcon);
